import { useState, useEffect, useCallback } from 'react';

import { useBreakpointValue } from '@hooks';
import { Svg } from '@snippets';

import { themed } from './ThumbsNavigation.theme';

export const ThumbsNavigation = themed(({ theme, swiper, count }) => {
  const showNavPerBp = useBreakpointValue([false, false, count > 5, count > 6]);
  const [isStart, setIsStart] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [showNav, setShowNav] = useState(false);

  const setStartAndEndOnSwiperChange = useCallback(() => {
    if (!swiper) return () => {}; // Return empty cleanup function
    setIsStart(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
    const handleSlideChange = () => {
      setIsStart(swiper.isBeginning);
      setIsEnd(swiper.isEnd);
    };
    swiper.on('slideChange', handleSlideChange);
    return () => {
      swiper.off('slideChange', handleSlideChange);
    };
  }, [swiper]);
  useEffect(() => {
    const cleanup = setStartAndEndOnSwiperChange();
    return cleanup;
  }, [swiper]);

  useEffect(() => {
    setShowNav(showNavPerBp);
  }, [showNavPerBp]);

  return (
    <>
      <Svg
        alt="chevron"
        viewBox="0 0 16 16"
        src="/svgs/chevron/up.svg#up"
        onClick={() => swiper.slidePrev()}
        role="button"
        sx={{
          display: showNav ? 'block' : 'none',
          opacity: showNav && isStart ? 0 : 1,
          pointerEvents: showNav && isStart ? 'none' : 'auto',
          ...theme.up,
        }}
      />
      <Svg
        alt="chevron"
        viewBox="0 0 16 16"
        src="/svgs/chevron/down.svg#down"
        onClick={() => swiper.slideNext()}
        role="button"
        sx={{
          display: showNav ? 'block' : 'none',
          opacity: showNav && isEnd ? 0 : 1,
          pointerEvents: showNav && isEnd ? 'none' : 'auto',
          transition: 'opacity 0.15s ease-in-out',
          ...theme.down,
        }}
      />
    </>
  );
});

ThumbsNavigation.displayName = 'ThumbsNavigation';
